<template>
  <div style="overflow-x: hidden !important">
    <!-- Show AppNavbar only if not on the /questionnaire route -->
    <AppNavbar v-if="showNavbar" />
    <nuxt />
  </div>
</template>

<script>
export default {
  components: {
    AppNavbar: () => import("@/components/AppNavbar"),
  },
  computed: {
    showNavbar() {
      // This hides the navbar only on the questionnaire page
      return this.$route.path !== "/questionnaire";
    },
  },
  data() {
    return {
      showHideSpinner: true,
    };
  },
  mounted() {
    this.showHideSpinner = false;
  },
};
</script>

<style>
html {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
